/**
 * KAN-799: расход токенов OpenRouter за месяц по моделям (из истории ключа платформы).
 * Строки готовит lib/expensesTokens, здесь только рендер. Поля models нет: блока нет.
 */
import { tokensModelRows } from '@/lib/expensesTokens';
import type { ExpenseItem } from '@/types/expenses';

export function TokensModelsList({ item }: { item: ExpenseItem | undefined }): JSX.Element | null {
  const rows = tokensModelRows(item);
  if (!rows.length) return null;
  return (
    <div className="mt-4" data-testid="tokens-models">
      <p className="mb-1 text-xs text-gray-500">По моделям за месяц (завершённые сутки UTC)</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-gray-400">
              <th className="py-1 pr-3 font-normal">Модель</th>
              <th className="py-1 pr-3 text-right font-normal">$</th>
              <th className="py-1 pr-3 text-right font-normal">₽</th>
              <th className="py-1 text-right font-normal">Запросов</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr
                key={row.model}
                className="border-t border-gray-100"
                data-testid={`tokens-model-${row.model}`}
              >
                <td className="break-all py-1 pr-3 text-gray-900">{row.model}</td>
                <td className="py-1 pr-3 text-right tabular-nums text-gray-900">{row.usd}</td>
                <td className="py-1 pr-3 text-right tabular-nums text-gray-500">{row.rub}</td>
                <td className="py-1 text-right tabular-nums text-gray-500">{row.requests}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
